export const APP_VERSION = {
    version: '2.0.0',
    commit: 'local',
    buildDate: ''
};
